import React from 'react'
import { graphql } from 'gatsby'
import PropTypes from 'prop-types'

import Layout from '../components/Layout/index'
import Section from '../components/Section/index'
import SubHeader from '../components/SubHeader/index'

const InfoPage = ({ data: { contentfulInfo } }) => {
  const body = contentfulInfo.body.childMarkdownRemark.html
  return (
    <Layout>
      {
        <>
          <Section variant="header">
            <SubHeader heading="Tietoa minusta" />
          </Section>
          <Section variant="narrow">
            <div
              className="blog-post"
              // eslint-disable-next-line react/no-danger
              dangerouslySetInnerHTML={{
                __html: body,
              }}
            />
          </Section>
        </>
      }
    </Layout>
  )
}

export default InfoPage

InfoPage.propTypes = {
  data: PropTypes.objectOf(PropTypes.objectOf(PropTypes.any).isRequired)
    .isRequired,
}

export const query = graphql`
  query {
    contentfulInfo {
      body {
        childMarkdownRemark {
          html
        }
      }
    }
  }
`
